const cancelDialog = {
	alert:
		"Note! This action can be undone until <strong>{{date}}</strong>. On <strong>{{date}}</strong> the PBS datastore will be <strong>permanently</strong> deleted.",
	description:
		"When you cancel this service, it will end on <strong>({{date}})</strong> and the data will be permanently deleted. To confirm, we ask you to repeat the name of the PBS (<strong>{{name}}</strong>) below.",
	input: {
		label: "PBS Name",
		placeholder: "Repeat PBS name",
	},
	messages: {
		success:
			"Your request to cancel PBS <strong>{{name}}</strong> has been successfully received. Your PBS will be canceled and deleted by <strong>{{date}}</strong>.",
	},
	submit_button: "Cancel PBS",
	title: "Cancel PBS",
};

const cancellationPending = {
	button: "Cancel cancellation",
	description:
		"Note! This PBS service has been cancelled and will no longer be available from <strong>{{date}}</strong>. You can still cancel this action now.",
	dialog: {
		description:
			"Are you sure you want to undo the PBS cancellation for <strong>{{name}}</strong>? The service will be billed again.",
		messages: {
			success:
				"The cancellation for PBS <strong>{{name}}</strong> has been successfully undone. The service remains active.",
		},
		title: "Cancel this PBS cancellation",
	},
};

const edit = {
	status_messages: {
		success: "Your PBS has been successfully updated!",
	},
	title: "Manage PBS - {{name}}",
};

const editSync = {
	no_sync_job:
		"No sync job found for PBS <strong>{{name}}</strong>. Please ensure this PBS has an active sync job configured.",
	title: "Manage PBS sync - {{name}}",
};

const overview = {
	bttn_create: "Create Tuxis PBS",
	card: {
		body: {
			free_version: "Free Version",
			hostname: "PBS Hostname",
			in_use: "In use",
			location: "Server Location",
			name: "Datastore Name",
			new: "Recently Created",
			username: "PBS User",
		},
		footer: {
			bttn: "Show details",
		},
		progress: {
			auto_expand: {
				chart_icon: "When your datastore reaches this limit, it will automatically expand.",
				notification:
					"You will receive an email notification when the datastore exceeds the limit of <strong>{{value}}</strong>.",
			},
			limited_size: {
				data_usage: "{{current}} of {{total}}",
				notification:
					"You will receive an email notification when there is less than <strong>{{value}}</strong> storage space left in the datastore.",
			},
			no_usage_alert: "Currently, datastore usage cannot be retrieved. Please try again later.",
			title: "Datastore Usage",
		},
	},
	empty: "You do not have any Tuxis PBS account yet",
	title: "Tuxis PBS Overview",
};

const page = {
	alert_tile: {
		alert_email_address: "Notification Address",
		alert_pruning: {
			disabled: "No",
			enabled: "Yes",
			label: "Notify on pruning errors",
		},
		alert_threshold: {
			disabled: "Never",
			enabled_auto_expand: "more than <strong>{{value}}</strong> is in use",
			enabled_limited_size: "less than <strong>{{value}}</strong> space is free.",
			label: "Notify when",
		},
		title: "Notifications",
	},
	current_usage: {
		in_use: "Currently in use",
		quota_limited_size: "Maximum datastore capacity",
		title: "Current Usage",
	},

	data_usage: {
		title: "Storage Usage",
	},
	delete_button: "Cancel PBS",
	edit_button: "Edit PBS",

	info_tile: {
		description: "Description",
		host: "PBS Hostname",
		location: "Server Location",
		name: "Datastore Name",

		product_config: {
			auto_expand: "Grow as you go",
			free_version: "Datastore fixed limit - Free",
			limited_size: "Datastore fixed limit",
			title: "Storage configuration",
		},
		product_variant: {
			free: "Tuxis PBS Free - 150 GB",
			paid: "Tuxis PBS per 1TB",
			sync_job: "Synced Datastore variant",
			title: "Datastore variant",
		},
		relation_title: "Linked relation",
		title: "PBS Information",
		username: "PBS User",
	},
	password_tile: {
		credentials_saved_button: "I saved the credentials",
		description:
			"The login credentials are stored in the password vault for <strong>30 days</strong>. Save these credentials in your own password manager. When logging in to the PBS web portal, choose the realm <strong>@pbs - Proxmox Backup authentication server</strong>.\nTo connect your Proxmox VE-server(s), please use the API-key that we have created for you.",
		description_completed:
			"You have saved the credentials from the password vault in your password manager. When logging in to the PBS web portal, choose the realm <strong>@pbs - Proxmox Backup authentication server</strong>.\nTo connect your Proxmox VE-server(s), please use the API-key that we have created for you.",
		password_vault_button: "Go to password vault",
		title: "PBS Login Credentials",
	},
	sync_job: {
		link_pbs_external: "View sync job",
		pbs_source_id: "Selected Tuxis PBS",
		remote_auth_id: "Auth ID",
		remote_datastore: "Remote datastore",
		remote_host: "Remote host",
		schedule: "Sync interval",
		source_pbs_variant: "Source PBS variant",
		ssl_fingerprint: "SSL fingerprint",
		sync_status: "Sync status",
		title: "Sync job",
	},
	sync_job_dialog_delete: {
		description:
			"Are you sure you want to delete the sync job for PBS <strong>{{datastore_name}}</strong>?",
		success: "The sync job is successfully removed for PBS <strong>{{datastore_name}}</strong>!",
		title: "Delete sync job?",
		warning:
			"Warning! Once a sync job is deleted, it cannot be recreated for this PBS. The PBS service itself will remain and must be cancelled separately.",
	},
};

const table = {
	body: {
		is_free_version: "- Free",
	},
	header: {
		cancellation_pending: "Cancelled",
		created_at: "Created at",
		datastore_config: "Configuration",
		datastore_name: "Datastore name",
		host: "Hostname",
		id: "PBS id",
		location: "Server location",
	},
};

const manage = {
	cancel_dialog: cancelDialog,
	cancellation_pending: cancellationPending,
	edit: edit,
	edit_sync: editSync,
	overview: overview,
	page: page,
	table: table,
};

export default manage;
